module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phone_hint":"Country code and phone number.","Номер телефона":"Phone number","Код зоны":"Area code"},"ru":{"phone_hint":"Код страны и номер телефона."}}')
  delete Component.options._Ctor
}
